import { Capacitor } from "@capacitor/core";

// Haptic feedback utility for native iOS feel
export const hapticFeedback = {
  light: () => {
    if (Capacitor.isNativePlatform()) {
      // Use Capacitor's Haptics if available, otherwise fallback to web
      try {
        import("@capacitor/haptics").then(({ Haptics, ImpactStyle }) => {
          Haptics.impact({ style: ImpactStyle.Light });
        });
      } catch (error) {
        // Fallback for web
        if ("vibrate" in navigator) {
          navigator.vibrate(10);
        }
      }
    } else if ("vibrate" in navigator) {
      // Web fallback
      navigator.vibrate(10);
    }
  },

  medium: () => {
    if (Capacitor.isNativePlatform()) {
      try {
        import("@capacitor/haptics").then(({ Haptics, ImpactStyle }) => {
          Haptics.impact({ style: ImpactStyle.Medium });
        });
      } catch (error) {
        if ("vibrate" in navigator) {
          navigator.vibrate(20);
        }
      }
    } else if ("vibrate" in navigator) {
      navigator.vibrate(20);
    }
  },

  heavy: () => {
    if (Capacitor.isNativePlatform()) {
      try {
        import("@capacitor/haptics").then(({ Haptics, ImpactStyle }) => {
          Haptics.impact({ style: ImpactStyle.Heavy });
        });
      } catch (error) {
        if ("vibrate" in navigator) {
          navigator.vibrate(50);
        }
      }
    } else if ("vibrate" in navigator) {
      navigator.vibrate(50);
    }
  },

  success: () => {
    if (Capacitor.isNativePlatform()) {
      try {
        import("@capacitor/haptics").then(({ Haptics, NotificationType }) => {
          Haptics.notification({ type: NotificationType.Success });
        });
      } catch (error) {
        if ("vibrate" in navigator) {
          navigator.vibrate([10, 50, 10]);
        }
      }
    } else if ("vibrate" in navigator) {
      navigator.vibrate([10, 50, 10]);
    }
  },

  error: () => {
    if (Capacitor.isNativePlatform()) {
      try {
        import("@capacitor/haptics").then(({ Haptics, NotificationType }) => {
          Haptics.notification({ type: NotificationType.Error });
        });
      } catch (error) {
        if ("vibrate" in navigator) {
          navigator.vibrate([100, 50, 100]);
        }
      }
    } else if ("vibrate" in navigator) {
      navigator.vibrate([100, 50, 100]);
    }
  }
};